import TouchspinContainer from "../../Componant/FormWidgets/Touchspin";

const Touchspin = () => {
  return (
    <div className="page-body">
      <TouchspinContainer />
    </div>
  );
};

export default Touchspin;
